import { apiClient } from '@/lib/api-client';

export async function likePost(postId: string, userId: string) {
  try {
    await apiClient.likePost(postId);
    return { success: true };
  } catch (error) {
    console.error('Error liking post:', error);
    throw error;
  }
}

export async function unlikePost(postId: string, userId: string) {
  try {
    await apiClient.unlikePost(postId);
    return { success: true };
  } catch (error) {
    console.error('Error unliking post:', error);
    throw error;
  }
}

export async function toggleLike(postId: string, userId: string, isLiked: boolean) {
  try {
    if (isLiked) {
      await apiClient.unlikePost(postId);
    } else {
      await apiClient.likePost(postId);
    }
    return { success: true, liked: !isLiked };
  } catch (error) {
    console.error('Error toggling like:', error);
    throw new Error('Failed to toggle like');
  }
}

export async function repostPost(postId: string, userId: string) {
  try {
    // Note: repost functionality would need to be added to API client
    const response = await fetch(`${process?.env?.NEXT_PUBLIC_API_URL}/posts/${postId}/repost`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
      }
    });
    
    if (!response.ok) {
      throw new Error('Failed to repost');
    }
    return await response.json();
  } catch (error) {
    console.error('Error reposting:', error);
    throw error;
  }
}